let localStorageStub = {};
export let localStorageInterface = {
  setItem: (key, value) => {
    localStorageStub[key] = value;
    // eslint-disable-next-line no-console
    console.error('initialize localStorageInterface with localStorageInterfaceInit or initializeUtilsCore first...');
  },
  getItem: (key) => localStorageStub[key],
  removeItem: (key) => delete localStorageStub[key],
  clear: () => {
    localStorageStub = {};
  },
  key: (index) => Object.keys(localStorageStub)[index],
  length: () => Object.keys(localStorageStub).length,
};

export const localStorageInrerfaceInit = (storage) => {
  localStorageInterface = storage || localStorageInterface;
};
